import React from 'react';
import { RevealOnScroll } from './RevealOnScroll';
const stats = [{
  value: '89%',
  label: 'Reducción de sofocos en 21 días'
}, {
  value: '3,000+',
  label: 'Mujeres ya lo aplicaron'
}, {
  value: '4.8★',
  label: 'Calificación promedio'
}];
export function SolutionIntro() {
  return <section className="w-full bg-wine px-5 py-10 text-white md:py-16" aria-labelledby="solution-heading" data-id="element-185">
      <div className="mx-auto max-w-container text-center" data-id="element-186">
        <h2 id="solution-heading" className="font-serif italic text-[24px] font-medium leading-[1.2] text-cream md:text-[28px]" data-id="element-187">
          El método que cambió todo para más de 3,000 mujeres
        </h2>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-4" data-id="element-188">
          {stats.map((s, i) => <RevealOnScroll key={i} delay={i * 0.08} data-id="element-189">
              <div className="text-center" data-id="element-190">
                <div className="font-sans text-[36px] font-semibold leading-none text-pinkLight" data-id="element-191">
                  {s.value}
                </div>
                <div className="mt-2 text-[13px] text-cream/90" data-id="element-192">{s.label}</div>
              </div>
            </RevealOnScroll>)}
        </div>
      </div>
    </section>;
}